import { memo } from "react";
import type { LoaderCommonProps } from "../types";
import { tokens } from "../styles/tokens";
import { Skeleton } from "./Skeleton";

const LINE_WIDTHS = ["100%", "92%", "78%", "100%", "88%", "65%"];

export const TextLoader = memo(function TextLoader({
  rows = 6,
  animated = true,
  width = "100%",
  height,
  className,
}: LoaderCommonProps) {
  const safeRows = Math.max(1, rows);

  return (
    <div
      className={className}
      style={{
        width,
        height,
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacing.sm,
      }}
    >
      {Array.from({ length: safeRows }).map((_, i) => (
        <Skeleton
          key={`line-${i}`}
          width={LINE_WIDTHS[i % LINE_WIDTHS.length]}
          height={14}
          animated={animated}
        />
      ))}
    </div>
  );
});
